import { render, staticRenderFns } from "./PassportDetail.vue?vue&type=template&id=3dfe4b83&"
import script from "./PassportDetail.vue?vue&type=script&lang=js&"
export * from "./PassportDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports